import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { auth0Config } from 'app/configs/auth0.config';
import { apiErrorInterceptorFn, tokenErrorInterceptorFn } from 'app/utils/error-interceptor';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        importProvidersFrom([BrowserAnimationsModule]),
        provideHttpClient(withInterceptors([tokenErrorInterceptorFn, authHttpInterceptorFn, apiErrorInterceptorFn])),
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline', subscriptSizing: 'dynamic' }
        },
        provideAuth0(auth0Config)
    ]
};
